/* GASSISA
=========================================================================================
 * Descripcion: TextField del sistema. Es el unico TextField que se debe importar
 *              en toda la aplicacion: ademas de todo lo que acepta el TextField
 *              de MUI, fuerza en el <input> nativo la desactivacion del
 *              autocompletado del navegador (ventanas emergentes molestas):
 *                autoComplete="off"  -> sin sugerencias de autocompletado
 *                autoCorrect="off"   -> sin correccion automatica (movil)
 *                autoCapitalize="off"-> sin mayuscula inicial (movil)
 *                spellCheck="false"  -> sin revisión ortográfica
 *              Los modos explícitos de inputProps / slotProps.htmlInput
 *              conservan prioridad, excepto enterKeyHint, fijado a "enter".
 * Historial de cambios:
 * ---------------------------------------------------------------------------------------
 *    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
 * ---------------------------------------------------------------------------------------
 *      1       | 06/10/2026 | LIC. José Luis Aragón C.                       | Creación
 *      2       | 09/10/2026 | LIC. José Luis Aragón C.                       | Teclado nativo alfanumérico con Enter
 * ---------------------------------------------------------------------------------------
 */

import { TextField as MuiTextField } from "@mui/material";

const ATRIBUTOS_ENTRADA = {
    autoComplete: "off",
    autoCorrect: "off",
    autoCapitalize: "off",
    spellCheck: "false",
};

export default function TextField(props) {
    const { inputProps, slotProps, inputMode, enterKeyHint, ...resto } = props;
    const usarEntradaTexto = !resto.type || ["text", "search", "password"].includes(resto.type);
    return (
        <MuiTextField
            {...resto}
            slotProps={{
                ...slotProps,
                htmlInput: {
                    ...ATRIBUTOS_ENTRADA,
                    ...(usarEntradaTexto ? { inputMode: "text" } : {}),
                    ...(inputMode ? { inputMode } : {}),
                    ...inputProps,
                    ...slotProps?.htmlInput,
                    enterKeyHint: enterKeyHint === "enter" ? enterKeyHint : "enter",
                },
            }}
        />
    );
}
